import script from "./OperatorApplicationDialogTextarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationDialogTextarea.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationDialogTextarea.vue?vue&type=style&index=0&id=487b8f2c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487b8f2c"]])

export default __exports__